import {Component, computed, input, linkedSignal, output} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {FulfillmentType} from '@frontend/directus';
import {SubcriteriaAttribute} from '../provider-questionnaire.types';
import {AttributeFulfillmentTernaryComponent} from './attribute-fulfillment-ternary/attribute-fulfillment-ternary.component';
import {AttributeFulfillmentBooleanComponent} from './attribute-fulfillment-boolean/attribute-fulfillment-boolean.component';
import {AttributeFulfillmentNumericComponent} from './attribute-fulfillment-numeric/attribute-fulfillment-numeric.component';
import {AttributeFulfillmentPercentageComponent} from './attribute-fulfillment-percentage/attribute-fulfillment-percentage.component';
import {ModelFieldButtonComponent} from '../../inputs/model-field/model-field-button/model-field-button.component';
import {ModelFieldTextComponent} from '../../inputs/model-field/model-field-text/model-field-text.component';
import {AttributeFulfillmentChange} from './attribute-fulfillment-input.types';
import {AttributeFulfillmentTwoStageComponent} from './attribute-fulfillment-two-stage/attribute-fulfillment-two-stage.component';
import {TwoStageAnswerChange} from './attribute-fulfillment-two-stage/attribute-fulfillment-two-stage.types';

@Component({
  selector: 'app-attribute-fulfillment-input',
  imports: [
    AttributeFulfillmentTernaryComponent,
    AttributeFulfillmentBooleanComponent,
    AttributeFulfillmentNumericComponent,
    AttributeFulfillmentPercentageComponent,
    AttributeFulfillmentTwoStageComponent,
    ModelFieldButtonComponent,
    ModelFieldTextComponent,
    TranslocoPipe,
  ],
  templateUrl: './attribute-fulfillment-input.component.html',
})
export class AttributeFulfillmentInputComponent {
  protected readonly FulfillmentType = FulfillmentType;

  readonly attribute = input.required<SubcriteriaAttribute>();
  readonly twoStage = input(false);
  readonly disabled = input.required<boolean>();
  readonly readonly = input(false);
  readonly testIdKey = input.required<string>();

  readonly valueChange = output<AttributeFulfillmentChange>();

  private readonly scoreAbsent = linkedSignal(() => this.attribute().scoreAbsent);

  readonly hasValue = computed(() => !this.scoreAbsent());

  readonly effectiveDisabled = computed(() => this.disabled() || !this.hasValue());
  readonly effectiveScore = computed(() =>
    this.hasValue() ? (this.attribute().score ?? null) : null,
  );
  readonly capabilityLevel = computed(() => this.attribute().capabilityLevel ?? null);
  readonly provisioningType = computed(() => this.attribute().provisioningType ?? null);
  readonly singleStageScore = computed(() =>
    this.attribute().singleStage && this.hasValue() ? (this.attribute().score ?? null) : null,
  );

  onScoreChange(score: number | undefined): void {
    this.valueChange.emit({score, scoreAbsent: false});
  }

  onTwoStageChange(change: TwoStageAnswerChange): void {
    this.valueChange.emit({
      score: change.factor,
      scoreAbsent: false,
      capabilityLevel: change.capabilityLevel,
      provisioningType: change.provisioningType,
    });
  }

  toggleValue(): void {
    const scoreAbsent = !this.scoreAbsent();
    this.scoreAbsent.set(scoreAbsent);
    this.valueChange.emit({
      score: scoreAbsent ? 0 : undefined,
      scoreAbsent,
      capabilityLevel: undefined,
      provisioningType: undefined,
    });
  }
}
